<template>
	<div id="skinmgr" class="skinmgr" :style="{'height': height + 'px'}">
		<div class="left">
			<div class="logo iconfont icon-bitmoji"></div>
			<div class="left-box">
				<a v-for="item in menuTree" :key="item.path" :class="item.isactive" @click="jump(item.path)"
					v-show="item.isShow">
					<i :class="'iconfont '+ item.icon"></i>
					<span>{{item.name}}</span>
				</a>
			</div>
		</div>
		<div v-if="middle" class="middle">
			<!-- 营销二类目录 start-->
			<div v-show="yingxiao" class="mnRecord">
				<h2>{{$i18n.t('menu_second_skin').sell}}</h2>
				<!-- <span @click="jump(menuTree.forSell.second.question.path)" :class="menuTree.forSell.second.question.isactive">
          {{menuTree.forSell.second.question.name}}
        </span>-->
				<span @click="jump(menuTree.forSell.second.lottory.path)"
					:class="menuTree.forSell.second.lottory.isactive">{{menuTree.forSell.second.lottory.name}}</span>
			</div>
			<!-- 营销二类目录 end-->
			<!-- 配置二类目录 start-->
			<div v-show="peizhi" class="baseSet">
				<h2>{{$i18n.t('menu_second_skin').base}}</h2>
				<span @click="jump(menuTree.systemSet.second.qrbaseset.path)"
					:class="menuTree.systemSet.second.qrbaseset.isactive">
					{{menuTree.systemSet.second.qrbaseset.name}}
				</span>
				<span @click="jump(menuTree.systemSet.second.numberbaseset.path)"
					:class="menuTree.systemSet.second.numberbaseset.isactive">{{menuTree.systemSet.second.numberbaseset.name}}</span>
			</div>
			<div v-show="peizhi" class="line"></div>
			<div v-show="peizhi" class="activeSet">
				<h2>{{$i18n.t('menu_second_skin').text}}</h2>
				<span @click="jump(menuTree.systemSet.second.layertextset.path)"
					:class="menuTree.systemSet.second.layertextset.isactive">
					{{menuTree.systemSet.second.layertextset.name}}
				</span>
				<span @click="jump(menuTree.systemSet.second.deeptextset.path)"
					  :class="menuTree.systemSet.second.deeptextset.isactive">
					{{menuTree.systemSet.second.deeptextset.name}}
				</span>
				<!-- <span @click="jump(menuTree.systemSet.second.syntextset.path)" :class="menuTree.systemSet.second.syntextset.isactive">
          {{menuTree.systemSet.second.syntextset.name}}
        </span> -->
			</div>
			<div v-show="peizhi" class="line"></div>
			<div v-show="peizhi" class="elseSet">
				<h2>{{$i18n.t('menu_second_skin').else}}</h2>
				<span @click="jump(menuTree.systemSet.second.pushset.path)"
					:class="menuTree.systemSet.second.pushset.isactive" v-show="menuTree.systemSet.second.pushset.isShow">
					{{menuTree.systemSet.second.pushset.name}}
				</span>
				<span @click="jump(menuTree.systemSet.second.datashowtype.path)"
					:class="menuTree.systemSet.second.datashowtype.isactive">
					{{menuTree.systemSet.second.datashowtype.name}}
				</span>
				<!-- <span @click="jump(menuTree.systemSet.second.imageset.path)" :class="menuTree.systemSet.second.imageset.isactive">
          {{menuTree.systemSet.second.imageset.name}}
        </span> -->
			</div>
			<!-- 配置二类目录 end-->
		</div>
		<div :class="'right '+resetRightWidthClass">
			<div class="head">
				<div class="menutitle">
					<span class="shu">|</span>
					<span>{{titleText}}</span>
				</div>
				<el-select class="lanselect" v-model="language" size="mini"	@change="changeLanguage()">
					<el-option v-for="(item,index) in langArr" :label="item" :value="index" :key="index"></el-option>
				</el-select>
				<span class="font14 userinfo">
					<el-dropdown trigger="click" @command="handleCommand">
						<span class="el-dropdown-link">
							<i class="iconfont icondaogouyuanx"></i>
							{{userInfo.user_acct}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown" style="top:30px;">
							<el-dropdown-item command="a">{{$t("userinfo").detail}}</el-dropdown-item>
							<el-dropdown-item command="b">{{$t("userinfo").change_mobile}}</el-dropdown-item>
							<el-dropdown-item command="c">{{$t("userinfo").edit_pwd}}</el-dropdown-item>
							<el-dropdown-item command="d">{{$t("userinfo").logout}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</span>
				<!--
        <a v-if="language=='zh'" target="_blank" href="#" class="font14 fr">
          <i class="iconfont iconbangzhux"></i>
          {{$t("menu_second").help}}
        </a>
        <a v-else target="_blank" href="#" class="font14 fr">
          <i class="iconfont iconbangzhux"></i>
          {{$t("menu_second").help}}
        </a>
        -->
				<!-- <a target="_blank" href="#" class="font14 fr">
          <i class="iconfont iconxiaoxix"></i>
          {{$t("userinfo").message}}
        </a> -->
			</div>
			<div class="content">
				<el-scrollbar class="page-component__scroll">
					<router-view />
				</el-scrollbar>
			</div>
		</div>
		<el-dialog :title="$i18n.t('userinfo').detail" :visible.sync="detailVisible" width="500px">
			<el-form>
				<el-form-item v-if="language=='zh'" :label="$i18n.t('member').mobile" :label-width="formLabelWidth">
					<span>{{userInfo.mobile}}</span>
				</el-form-item>
				<el-form-item v-else :label="$i18n.t('member').form_user_email" :label-width="formLabelWidth">
					<span>{{userInfo.email}}</span>
				</el-form-item>
				<el-form-item :label="$i18n.t('member').form_user_name" :label-width="formLabelWidth">
					<el-input v-model="userInfo.user_acct"></el-input>
				</el-form-item>
				<el-form-item :label="$i18n.t('member').form_user_sex" :label-width="formLabelWidth">
					<el-radio v-model="userInfo.sex" label="1">{{$i18n.t('userinfo').nan}}</el-radio>
					<el-radio v-model="userInfo.sex" label="0">{{$i18n.t('userinfo').nv}}</el-radio>
				</el-form-item>
				<el-form-item v-if="language=='zh'" :label="$i18n.t('member').form_user_email" :label-width="formLabelWidth">
					<el-input v-model="userInfo.email"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="btn_blue_boder" @click="detailVisible = false">{{$t("normal_cancle")}}</el-button>
				<el-button type="primary" @click="subimtDetailSave()">{{$t("normal_sure")}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="$i18n.t('userinfo').change_mobile" :visible.sync="mobileVisible" width="500px">
			<el-form>
				<el-form-item v-if="language=='zh'" :label="$i18n.t('member').mobile" :label-width="formLabelWidth">
					<span>{{userInfo.mobile}}</span>
				</el-form-item>
				<el-form-item v-else :label="$i18n.t('member').form_user_email" :label-width="formLabelWidth">
					<span>{{userInfo.email}}</span>
				</el-form-item>
				<el-form-item v-if="language=='zh'" :label="$i18n.t('userinfo').vcode" :label-width="formLabelWidth">
					<el-input v-model="userInfo.vcode_1" style="width:61%"></el-input>
					<el-button @click="sendSms(1)" class="btn_blue_boder" style="width:35%;top:1px;margin-left:2%;">
						{{vcodeText_1}}</el-button>
				</el-form-item>
				<el-form-item v-if="language=='zh'" :label="$i18n.t('userinfo').newmobile"
					:label-width="formLabelWidth">
					<el-input v-model="userInfo.newmobile"></el-input>
				</el-form-item>
				<el-form-item v-if="language!='zh'" :label="$i18n.t('member').form_user_newemail" :label-width="formLabelWidth">
					<el-input v-model="userInfo.newemail"></el-input>
				</el-form-item>
				<el-form-item v-if="language!='zh'" :label="$i18n.t('userinfo').vcode" :label-width="formLabelWidth">
					<el-input v-model="userInfo.vcode_2" style="width:61%"></el-input>
					<el-button @click="sendSms(2)" class="btn_blue_boder" style="width:35%;top:1px;margin-left:2%;">
						{{vcodeText_2}}</el-button>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="btn_blue_boder" @click="mobileVisible = false">{{$t("normal_cancle")}}</el-button>
				<el-button type="primary" @click="subimtMobileSave()">{{$t("normal_sure")}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="$i18n.t('userinfo').edit_pwd" :visible.sync="pwdVisible" width="500px">
			<el-form>
				<el-form-item v-if="language=='zh'" :label="$i18n.t('member').mobile" :label-width="formLabelWidth">
					<span>{{userInfo.mobile}}</span>
				</el-form-item>
				<el-form-item v-else :label="$i18n.t('member').email" :label-width="formLabelWidth">
					<span>{{userInfo.email}}</span>
				</el-form-item>
				<el-form-item :label="$i18n.t('userinfo').vcode" :label-width="formLabelWidth">
					<el-input v-model="userInfo.vcode_3" style="width:61%"></el-input>
					<el-button @click="sendSms(3)" class="btn_blue_boder" style="width:35%;top:1px;margin-left:2%;">
						{{vcodeText_3}}</el-button>
				</el-form-item>
				<el-form-item :label="$i18n.t('userinfo').pwd" :label-width="formLabelWidth">
					<el-input v-model="userInfo.pwd"></el-input>
				</el-form-item>
				<el-form-item :label="$i18n.t('userinfo').repwd" :label-width="formLabelWidth">
					<el-input v-model="userInfo.repwd"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="btn_blue_boder" @click="pwdVisible = false">{{$t("normal_cancle")}}</el-button>
				<el-button type="primary" @click="subimtPwdSave()">{{$t("normal_sure")}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: "skinmgr",
		data() {
			return {
				formLabelWidth: '130px',
				detailVisible: false,
				mobileVisible: false,
				pwdVisible: false,
				height: 0,
				titleText: "",
				middle: false,
				resetRightWidthClass: "",
				yingxiao: false,
				peizhi: false,
				language: "zh",
				menuTree: {
                    // tipsList: {
                    //   name: '操作提示',
                    //   isactive: "",
                    //   path: "/skinmgr/tipsList",
                    //   icon: "iconchanpingx",
                    //   isShow: true
                    // },
                    home: {
                        name: this.$i18n.t('menu_first_skin').home,
                        isactive: '',
                        path: '/skinmgr/home',
                        icon: 'icongaikuangx',
                        isShow: true
                    },
                    goodsList: {
                        name: this.$i18n.t("menu_first_skin").goods,
                        isactive: "",
                        path: "/skinmgr/goodsList",
                        icon: "iconchanpingx",
                        isShow: false
                    },
                    recordsList: {
                        name: this.$i18n.t("menu_first_skin").skintest,
                        isactive: "",
                        path: "/skinmgr/recordsList",
                        icon: "iconcefux",
                        isShow: false
                    },
                    facearchitect: {
                        name: this.$i18n.t("menu_first_skin").facearchitect,
                        isactive: "",
                        path: "/skinmgr/facearchitect",
                        icon: "iconpeizhi",
                        isShow: false
                    },
                    systemSet: {
                        name: this.$i18n.t("menu_first_skin").set,
                        isactive: "",
                        path: "/skinmgr/numberbaseset",
                        icon: "iconpeizhi",
                        isShow: false,
                        second: {
                            qrbaseset: {
                                name: this.$i18n.t("menu_second_skin").qrbaseset,
                                isactive: "off",
                                path: "/skinmgr/qrbaseset",
                                isShow: true,
                            },
                            numberbaseset: {
                                name: this.$i18n.t("menu_second_skin").numberbaseset,
                                isactive: "off",
                                path: "/skinmgr/numberbaseset",
                                isShow: true,
                            },
                            layertextset: {
                                name: this.$i18n.t("menu_second_skin").layertextset,
                                isactive: "off",
                                path: "/skinmgr/layertextset",
                                isShow: true,
                            },
                            deeptextset: {
                                name: this.$i18n.t("menu_second_skin").deeptextset,
                                isactive: "off",
                                path: "/skinmgr/deeptextset",
                                isShow: true,
                            },
                            syntextset: {
                                name: this.$i18n.t("menu_second_skin").syntextset,
                                isactive: "off",
                                path: "/skinmgr/syntextset",
                                isShow: true,
                            },
                            pushset: {
                                name: this.$i18n.t("menu_second_skin").pushset,
                                isactive: "off",
                                path: "/skinmgr/pushset",
                                isShow: true,
                            },
                            imageset: {
                                name: this.$i18n.t("menu_second_skin").imageset,
                                isactive: "off",
                                path: "/skinmgr/imageset",
                                isShow: true,
                            },
                            datashowtype: {
                                name: this.$i18n.t("menu_second_skin").datashowtype,
                                isactive: "off",
                                path: "/skinmgr/datashowtype",
								isShow: true
                            }
                        }
                    },
                    forSell: {
                        name: this.$i18n.t("menu_first_skin").sell,
                        isactive: "",
                        path: "/skinmgr/lottory",
                        icon: "iconzizhutuiguang",
                        isShow: false,
                        second: {
                            question: {
                                name: this.$i18n.t("menu_second_skin").question,
                                isactive: "off",
                                path: "/skinmgr/question"
                            },
                            lottory: {
                                name: this.$i18n.t("menu_second_skin").lottory,
                                isactive: "off",
                                path: "/skinmgr/lottory"
                            }
                        }
                    },
                    memberList: {
                        name: this.$i18n.t("menu_first_skin").member,
                        isactive: "",
                        path: "/skinmgr/memberList",
                        icon: "icondaogouyuanx",
                        isShow: false
                    },
                    deviceList: {
                        name: this.$i18n.t("xunliema").menu[0],
                        isactive: "",
                        path: "/skinmgr/deviceList",
                        icon: "iconpeizhi",
                        isShow: false
                    },
                    deviceCreate: {
                        name: this.$i18n.t("xunliema").menu[1],
                        isactive: "",
                        path: "/skinmgr/deviceCreate",
                        icon: "iconpeizhi",
                        isShow: false
                    }
                },
				userInfo: {
					user_acct: '',
					mobile: '',
					newmobile: '',
					newemail: '',
					shop: '',
					power: '',
					parent_id: '',
					sex: '1',
					email: '',
					repwd: '',
					pwd: '',
					vcode_1: '',
					vcode_2: '',
					vcode_3: ''
				},
				counter_change_mobile_1: 0,
				counter_change_mobile_2: 0,
				counter_change_mobile_3: 0,
				timer_1: null,
				timer_2: null,
				timer_3: null,
				vcodeText_1: this.$i18n.t("userinfo").btn_get_sms,
				vcodeText_2: this.$i18n.t("userinfo").btn_get_sms,
				vcodeText_3: this.$i18n.t("userinfo").btn_get_sms,
				nowAsscessToken: '',
				langArr: this.langArrs
			};
		},
		watch: {
			$route: function() {
				this.setMenu();
			}
		},
		mounted() {
			this.language = localStorage.locale;
			let _this = this;
			this.height =
				window.innerHeight ||
				window.screen.availHeight ||
				document.body.clientHeight;
			window.onresize = function() {
				_this.height =
					window.innerHeight ||
					window.screen.availHeight ||
					document.body.clientHeight;
			};
			if (localStorage.locale !== 'zh') {
				this.formLabelWidth = '1.6rem'
			}
			this.initMenuTree();
			this.getUserInfo();
			this.initConf()
		},
		methods: {
			handleCommand(command) {
				if (command === 'a') { //打开编辑用户信息弹窗
					this.detailVisible = true
				} else if (command === 'b') { //打开更换手机号码弹窗
					this.mobileVisible = true
				} else if (command === 'c') { //打开修改密码弹窗
					this.pwdVisible = true
				} else if (command === 'd') { //登出
					this.setCookie("access_token", "", "/");
					localStorage.removeItem("access_token");
					this.$router.push({
						path: "/#"
					});
				}
				//this.$message('click on item ' + command);
			},
			setSessionData(data) {
				this.userInfo = data
				sessionStorage.userInfo = JSON.stringify(data);
				this.setMenu()
			},
			initConf() {
				let data = {
					code: 'record_expprt,customer_expprt,goods_mode,platform'
				};
				let _this = this
				this.axios
					.post("/skinMgrSrv/config/get", this.formData(data))
					.then(function(response) {
						if (response.data.code === 0) {
							localStorage.userConfs = JSON.stringify(response.data);
							if (response.data.goods_mode&&response.data.goods_mode=='solrx') {
                                _this.$set(_this.menuTree.systemSet.second.pushset, 'isShow', false)
							}
                            if (response.data.platform&&response.data.platform=='zsmkj') {
                                _this.$set(_this.menuTree.facearchitect, 'isShow', true)
                            }
							if (response.data.platform) {
								localStorage.platform == response.data.platform
							}
						}

					}).catch(function(res) {
						console.error(res)
					});
			},
			getUserInfo() {
				let _this = this
				this.axios({
					method: 'get',
					url: '/skinMgrSrv/user/get'
				}).then(function(res) {
					if (res.data.code == 0) {
						_this.setSessionData(res.data.userinfo)
						_this.nowAsscessToken = localStorage.access_token
					} else {
						_this.$message(this.$i18n.t('member').usererror)
						_this.setCookie("access_token", "", "/");
						localStorage.removeItem("access_token");
						_this.$router.push({
							path: "/#"
						});
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			initMenuTree() {
                for(let k in this.menuTree) {
                    this.$set(this.menuTree[k], 'isactive', '')
					if(this.menuTree[k].second){
                        for(let subk in this.menuTree[k].second) {
                            this.$set(this.menuTree[k].second[subk], 'isactive', 'off')
                        }
					}
                }

				this.getuser();
				if (sessionStorage.userInfo) {
					let data = JSON.parse(sessionStorage.userInfo);
					if (!data.parent_id) {
						this.$set(this.menuTree.memberList, 'isShow', true)
						this.$set(this.menuTree.goodsList, 'isShow', true)
						this.$set(this.menuTree.recordsList, 'isShow', true)
						this.$set(this.menuTree.systemSet, 'isShow', true)
						this.$set(this.menuTree.forSell, 'isShow', true)
					} else if (data.power) {
						var arr = data.power.split(',')
						for (let i in arr) {
							if (arr[i] == '1') {
								this.$set(this.menuTree.goodsList, 'isShow', true)
							}
							if (arr[i] == '2') {
								this.$set(this.menuTree.recordsList, 'isShow', true)
							}
							if (arr[i] == '3') {
								this.$set(this.menuTree.systemSet, 'isShow', true)
							}
							if (arr[i] == '4') {
								this.$set(this.menuTree.forSell, 'isShow', true)
							}
                            if (arr[i] == '5') {
                                this.$set(this.menuTree.facearchitect, 'isShow', true)
                            }
						}
					}
				}
			},
			getuser() {
				let _this = this
				if(sessionStorage.userSrv_user_get){
					let resdata = JSON.parse(sessionStorage.userSrv_user_get)
					if (resdata.code == 0 && resdata.attr && resdata.attr.auth_type == 99) {
					    if(_this.menuTree&&_this.menuTree.deviceList){
                            _this.$set(_this.menuTree.deviceList, 'isShow', true)
                            _this.$set(_this.menuTree.deviceCreate, 'isShow', true)
						}
                        _this.$set(_this.menuTree.facearchitect, 'isShow', true)
					}
					return false
				}
				
				this.axios({
					method: "post",
					url: "/userSrv/user/get",
					data: {}
				}).then(function(res) {
					if(res.data.code == 0 && res.data.attr){
						sessionStorage.userSrv_user_get = JSON.stringify(res.data)
					}
					if (res.data.code == 0 && res.data.attr && res.data.attr.auth_type == 99) {
					    if(_this.menuTree&&_this.menuTree.deviceList){
                            _this.$set(_this.menuTree.deviceList, 'isShow', true)
                            _this.$set(_this.menuTree.deviceCreate, 'isShow', true)
						}
                        _this.$set(_this.menuTree.facearchitect, 'isShow', true)
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			changeLanguage() {
				localStorage.language = this.language
				localStorage.locale = this.language
				location.reload()
			},
			clearCache() {
				let _this = this;
				let data = {};
				this.axios
					.post("/skinMgrSrv/config/about", this.formData(data))
					.then(function(response) {
						if (response.data.code === 0) {}
					});
			},
			jump(path) {
				if (this.nowAsscessToken !== localStorage.access_token) {
					window.location.reload(true)
				}
				this.$router.push({
					path: path
				});
			},
			setMenu() {
				let menuSelect = this.$route.path;
				this.initMenuTree();
				this.middle = false;
				this.resetRightWidthClass = "";
				console.log(this.menuTree);
				for (let i in this.menuTree) {
					if (this.menuTree[i].path == menuSelect) {
						this.$set(this.menuTree[i], "isactive", "is-active");
						this.titleText = this.menuTree[i].name;
						if(i == 'recordsList' && localStorage.locale == 'ko'){
							this.titleText = this.$i18n.t("menu_first_skin").skintestb
						}
					}
					if (this.menuTree[i].second) {
						for (let j in this.menuTree[i].second) {
							if (this.menuTree[i].second[j].path == menuSelect) {
								this.titleText = this.menuTree[i].second[j].name;
								
								this.$set(this.menuTree[i], "isactive", "is-active");
								this.$set(this.menuTree[i].second[j], "isactive", "on");
								this.resetRightWidthClass = "resetRightWidth";
								this.middle = true;
								this.yingxiao = false;
								this.peizhi = false;
								if (i == "systemSet") {
									this.yingxiao = false;
									this.peizhi = true;
								} else if (i == "forSell") {
									this.yingxiao = true;
									this.peizhi = false;
								}
							}
						}
					}
				}
				//对子页面的一些页面处理菜单状态
				if (menuSelect == "/skinmgr/goodsEdit") {
					this.$set(this.menuTree.goodsList, "isactive", "is-active");
					this.titleText = this.menuTree.goodsList.name;
				}
				if (menuSelect == "/skinmgr/editActive") {
					this.$set(this.menuTree.forSell, "isactive", "is-active");
					this.$set(this.menuTree.forSell.second.lottory, "isactive", "on");
					this.titleText = this.menuTree.forSell.second.lottory.name;
					this.resetRightWidthClass = "resetRightWidth";
					this.middle = true;
					this.yingxiao = true;
					this.peizhi = false;
				}
			},
			subimtDetailSave() {
				let _this = this
				if (this.userInfo.user_acct == '') {
					this.$message(this.$i18n.t('member').form_message_name)
					return false
				}
				let data = {
					id: -1,
					name: this.userInfo.user_acct,
					email: this.userInfo.email,
					sex: this.userInfo.sex
				}
				let olddata = JSON.parse(sessionStorage.userInfo)
				if (olddata.user_acct == data.name) {
					data.name = ''
				}
				if (olddata.email == data.email) {
					data.email = ''
				}
				if (olddata.sex == data.sex) {
					data.sex = ''
				}
				if (data.name === '' && data.email === '' && data.sex === '') {
					_this.$message(this.$i18n.t('userinfo').form_message_noedit)
					return false
				}
				if (data.sex == '0') {
					data.sex = '-1'
				}
				if (this.doing === true) {
					return false
				}
				this.doing = true
				this.axios.post('/skinMgrSrv/user/save', this.formData(data)).then(function(response) {
					_this.doing = false
					_this.detailVisible = false
					if (response.data.code === 0) {
						_this.$message(_this.$i18n.t("userinfo").detail_edit_success);
					} else {
						_this.$message(_this.$i18n.t("support_error"));
						
						// _this.$message(response.data.msg)
					}
				}).catch(function(res) {
					_this.detailVisible = false
					_this.doing = false
					console.log(res)
				})
			},
			subimtMobileSave() {
				let _this = this
				if (this.userInfo.vcode_1 == '') {
					_this.$message(this.$i18n.t('userinfo').form_message_vcode)
					return false
				}
				if (this.language == 'zh') {
					if (!this.userInfo.newmobile) {
						_this.$message(this.$i18n.t('userinfo').form_message_newmobile)
						return false
					}
				} else {
					if (!this.userInfo.newemail) {
						_this.$message(this.$i18n.t('userinfo').form_message_newmobile)
						return false
					}
				}
				if (this.userInfo.vcode_2 == '') {
					_this.$message(this.$i18n.t('userinfo').form_message_newvcode)
					return false
				}
				let data = {
					id: -1,
					mobile: this.userInfo.mobile,
					email: this.userInfo.email,
					vcode: this.userInfo.vcode_1,
					newmobile: this.userInfo.newmobile,
					newemail: this.userInfo.newemail,
					newvcode: this.userInfo.vcode_2,
					change_mobile_myself: 1
				}
				if (this.doing === true) {
					return false
				}
				this.doing = true
				this.axios.post('/skinMgrSrv/user/save', this.formData(data)).then(function(response) {
					_this.doing = false
					_this.mobileVisible = false
					if (response.data.code === 0) {
						_this.$message(_this.$i18n.t("userinfo").mobile_edit_success);
					} else {
						_this.$message(_this.$i18n.t("support_error"));
						// _this.$message(response.data.msg)
					}
				}).catch(function(res) {
					_this.mobileVisible = false
					_this.doing = false
					console.log(res)
				})
			},
			subimtPwdSave() {
				let _this = this
				if (this.userInfo.vcode_3 == '') {
					_this.$message(this.$i18n.t('userinfo').form_message_vcode)
					return false
				}
				if (this.userInfo.pwd == '') {
					_this.$message(this.$i18n.t('userinfo').form_message_pwd)
					return false
				}
				if (this.userInfo.pwd != this.userInfo.repwd) {
					_this.$message(this.$i18n.t('userinfo').form_message_repwd)
					return false
				}
				if (this.language == 'zh') {
					if (this.userInfo.mobile == '') {
						_this.$message(this.$i18n.t('userinfo').form_message_mobile)
						return false
					}
				} else {
					if (this.userInfo.email == '') {
						_this.$message(this.$i18n.t('userinfo').form_message_mobile)
						return false
					}
				}
				let data = {
					id: -1,
					mobile: this.userInfo.mobile,
					email: this.userInfo.email,
					vcode: this.userInfo.vcode_3,
					pwd: this.userInfo.pwd,
					repwd: this.userInfo.repwd,
					change_pwd: 1
				}
				if (this.doing === true) {
					return false
				}
				this.doing = true
				this.axios.post('/skinMgrSrv/user/save', this.formData(data)).then(function(response) {
					_this.doing = false
					_this.pwdVisible = false
					if (response.data.code === 0) {
						_this.$message(_this.$i18n.t("userinfo").pwd_edit_success);
					} else {
						_this.$message(_this.$i18n.t("support_error"));
						// _this.$message(response.data.msg)
					}
				}).catch(function(res) {
					_this.pwdVisible = false
					_this.doing = false
					console.log(res)
				})
			},
			sendSms(type) {
				if (type === 1 && this.counter_change_mobile_1 > 0) {
					return
				}
				if (type === 2 && this.counter_change_mobile_2 > 0) {
					return
				}
				if (type === 3 && this.counter_change_mobile_3 > 0) {
					return
				}
				if (type === 2 && this.userInfo.newmobile == '' && this.language == 'zh') {
					this.$message(this.$i18n.t('userinfo').form_message_newmobile)
					return
				}
				if (type === 2 && this.userInfo.newemail == '' && this.language == 'en') {
					this.$message(this.$i18n.t('userinfo').form_message_newemail)
					return
				}
				this.visible2 = false
				if (this.language == 'zh') {
					send(this, type)

					function send(self, ty) {
						let post = {
							mobile: '',
							biz: 1002,
							src: 11
						}
						if (ty === 1 || ty === 3) {
							post.mobile = self.userInfo.mobile
						} else {
							post.mobile = self.userInfo.newmobile
						}
						if (ty === 3) {
							post.biz = 1001
						}
						self.axios({
							method: 'post',
							url: '/sms/send',
							data: post
						}).then((response) => {
							let data = response.data
							if (data.code === 0) {
								if (ty === 1) {
									self.counter_change_mobile_1 = 60
									self.timer_1 = setInterval(() => {
										self.counter_change_mobile_1 -= 1
										if (self.counter_change_mobile_1 < 1) {
											clearInterval(self.timer_1)
											self.vcodeText_1 = self.$i18n.t("userinfo").btn_get_sms
										} else {
											self.vcodeText_1 = self.counter_change_mobile_1 + self.$i18n.t(
												"userinfo").after_send
										}
									}, 1000)
								}
								if (ty === 2) {
									self.counter_change_mobile_2 = 60
									self.timer_2 = setInterval(() => {
										self.counter_change_mobile_2 -= 1
										if (self.counter_change_mobile_2 < 1) {
											clearInterval(self.timer_2)
											self.vcodeText_2 = self.$i18n.t("userinfo").btn_get_sms
										} else {
											self.vcodeText_2 = self.counter_change_mobile_2 + self.$i18n.t(
												"userinfo").after_send
										}
									}, 1000)
								}
								if (ty === 3) {
									self.counter_change_mobile_3 = 60
									self.timer_3 = setInterval(() => {
										self.counter_change_mobile_3 -= 1
										if (self.counter_change_mobile_3 < 1) {
											clearInterval(self.timer_3)
											self.vcodeText_3 = self.$i18n.t("userinfo").btn_get_sms
										} else {
											self.vcodeText_3 = self.counter_change_mobile_3 + self.$i18n.t(
												"userinfo").after_send
										}
									}, 1000)
								}

							} else {
								self.$message({
									message: data.msg,
									type: 'warning'
								})
							}
						}).catch(function(err) {
							console.log(err)
						})
					}
				} else {
					let myreg =
						/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
					if (
						this.userInfo.email === "" ||
						this.userInfo.email == null ||
						!myreg.test(this.userInfo.email)
					) {
						this.$message(this.$i18n.t('register_email_notright'))
						return
					}
					this.visible2 = false
					sendEmail(this, type)

					function sendEmail(self, ty) {
						let post = {
							vcode: self.userInfo.vcode,
							email: self.userInfo.email,
							biz: 1000,
							src: 10,
							r: self.r,
							t: self.t
						}
						if (ty === 1 || ty === 3) {
							post.email = self.userInfo.email
						} else {
							post.email = self.userInfo.newemail
						}
						if (ty === 3) {
							//post.biz = 1001
						}
						self.axios({
							method: 'post',
							url: '/email/send',
							data: post
						}).then((response) => {
							let data = response.data
							if (data.code === 0) {
								if (ty === 1) {
									self.counter_change_mobile_1 = 60
									self.timer_1 = setInterval(() => {
										self.counter_change_mobile_1 -= 1
										if (self.counter_change_mobile_1 < 1) {
											clearInterval(self.timer_1)
											self.vcodeText_1 = self.$i18n.t("userinfo").btn_get_sms
										} else {
											self.vcodeText_1 = self.counter_change_mobile_1 + self.$i18n.t("userinfo").after_send
										}
									}, 1000)
								}
								if (ty === 2) {
									self.counter_change_mobile_2 = 60
									self.timer_2 = setInterval(() => {
										self.counter_change_mobile_2 -= 1
										if (self.counter_change_mobile_2 < 1) {
											clearInterval(self.timer_2)
											self.vcodeText_2 = self.$i18n.t("userinfo").btn_get_sms
										} else {
											self.vcodeText_2 = self.counter_change_mobile_2 + self.$i18n.t("userinfo").after_send
										}
									}, 1000)
								}
								if (ty === 3) {
									self.counter_change_mobile_3 = 60
									self.timer_3 = setInterval(() => {
										self.counter_change_mobile_3 -= 1
										if (self.counter_change_mobile_3 < 1) {
											clearInterval(self.timer_3)
											self.vcodeText_3 = self.$i18n.t("userinfo").btn_get_sms
										} else {
											self.vcodeText_3 = self.counter_change_mobile_3 + self.$i18n.t("userinfo").after_send
										}
									}, 1000)
								}
							} else {
								console.log(data.msg)
								self.$message({
									message: data.msg,
									type: 'warning'
								})
							}
						}).catch(function(err) {
							console.log(err)
						})
					}
				}
			}
		}
	};
</script>
<style lang="scss">
	.el-dropdown {
		height: 0.4rem;
	}
</style>
<style scoped lang="scss">
	#skinmgr {
		width: 100%;
		height: 100%;
		position: relative;

		.lanselect {
			float: right;
			width: 0.9rem;
			height: 0.2rem;
			line-height: 0.2rem;
			margin-top: 0.15rem;
		}

		a:hover {
			color: #458afe !important;
		}

		.left {
			display: inline-block;
			vertical-align: top;
			width: 0.8rem;
			height: 100%;
			overflow-y: auto;
			overflow-x: hidden;
			background-color: #1a1e22;

			.logo {
				padding-top: 0.33rem;
				box-sizing: border-box;
				width: 100%;
				height: 1.2rem;
				font-size: 0.5rem;
				color: #57aec9;
				text-align: center;
			}

			a {
				min-height: 0.65rem;
				text-align: center;
				line-height: 100%;
				padding-top: 0.1rem;
				display: block;
				cursor: pointer;
				
				font-size: 0.12rem;
				i {
					height: 0.3rem;
					line-height: 0.3rem;
					font-size: 0.2rem;
					display: block;
				}

				span {
					color: #8d8f91;
					font-size: 0.116rem;
					line-height: 0.2rem;
					padding: 0px 0.05rem;
					word-wrap: break-word;  
				}
			}

			.set {
				position: fixed;
				bottom: 0.25rem;
				width: 0.75rem;
				height: 0.5rem;
				text-align: center;
				padding-top: 0.22rem;
			}

			a.is-active,
			a:hover,
			a.is-active span,
			a:hover span {
				background-color: #444 !important;
				color: #fff !important;
			}

			a:hover i {
				color: #fff !important;
			}
		}

		.middle {
			width: 1.8rem;
			height: 100%;
			display: inline-block;
			background-color: #fff;

			div {
				width: 100%;
				height: 1.55rem;
				color: #1b1b1b;

				h2 {
					font-size: 0.15rem;
					font-weight: 700;
					margin: 0.25rem 0.25rem 0.15rem;
				}

				span {
					width: 1.25rem;
					min-height: 0.18rem;
					border-radius: 5px;
					font-size: 0.13rem;
					margin: 0px 0.117rem;
					display: block;
					line-height: 110%;
					padding:  0.05rem 0.1rem;
					margin-bottom: 0.1rem;
					cursor: pointer;

					i {
						width: 0.116rem;
						height: 17px;
						background-image: url(../assets/img/onright.png);
						background-size: contain;
						background-repeat: no-repeat;
						background-position: center;
						display: inline-block;
						float: right;
						margin-top: 0.09rem;
						margin-right: 0.08rem;
					}
				}

				span.off {
					background-color: #fff;
				}

				span.on,
				span:hover {
					background-color: #f3f3f3;
				}
			}

			.baseSet,
			.elseSet,
			.activeSet {
				min-height: 1.5rem;
				height: auto;
			}

			.baseSet {
				h2 {
					margin-top: 0.45rem;
				}
				span{
					word-wrap: break-word; 
					display: block;
				}
			}

			.activeSet {
				height: 1.6rem;
			}

			div.mnRecord {
				height: 2.5rem;

				h2 {
					margin-top: 0.45rem;
				}
			}

			.line {
				height: 1px;
				border-top: 1px solid #ccc;
				width: 1.5rem;
				margin-left: 0.08rem;
			}

			.peizhielse {
				margin-top: 1rem;
			}
		}

		.right {
			position: relative;
			display: inline-block;
			vertical-align: top;
			height: 100%;
			width: calc(100% - 0.833rem);

			.head {
				position: absolute;
				width: 100%;
				height: 0.5rem;
				box-shadow: 0rem 0.01rem 0.04rem 0rem rgba(217, 217, 217, 0.5);
				padding-right: 0.16rem;
				box-sizing: border-box;
				background-color: #fff;
				z-index: 2;
				color: $color59;

				i {
					width: 0.15rem;
					height: 0.21rem;
					font-size: 0.1rem;
					color: #000;
					display: inline-block;
				}

				.menutitle {
					color: #000;
					width: 3rem;
					height: 0.5rem;
					display: inline-block;
					font-size: 0.15rem;
					line-height: 0.5rem;
					margin-left: 0.167rem;

					span {
						float: none;
					}

					.shu {
						color: #57aec9;
						font-weight: 700;
					}
				}

				.back {
					margin-left: 0.167rem;
				}

				span,
				a {
					display: inline-block;
					float: right;
					height: 0.5rem;
					line-height: 14px;
					margin: 0.2rem 0.1rem;
				}

				span.userinfo {
					margin: 0;
				}

				button {
					float: right;
					margin-top: 0.09rem;
					margin-left: 0.15rem;
				}
			}

			.content {
				width: 100%;
				height: 100%;
				overflow: hidden;
				padding-top: 0.5rem;
				box-sizing: border-box;
				background-color: #f3f3f3;

				.page-component__scroll {
					height: 100%;
				}

				.page-scrollbar__wrap {
					overflow: auto;
				}
			}
		}

		.resetRightWidth {
			width: calc(100% - 2.72rem);
		}

		.new {
			width: 0.3rem;
			height: 0.15rem;
			line-height: 0.14rem;
			background-color: #57aec9;
			color: #fff;
			text-align: center;
			font-size: 0.08rem;
			position: absolute;
			top: 0;
			right: 0.1rem;
			border-radius: 0.05rem;
			display: block;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/skinmgr.vue